export const identityDialogIndexEnums = {
  LOCKOUT: 'LOCKOUT',
  ERROR: 'ERROR',
  LOADING: 'LOADING',
  OPENING: 'OPENING',
  SUBMIT: 'SUBMIT',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
};
